import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function DesktopHome() {

    useEffect(() => {

    }, [])



    return (
        <>
            <div className="card">
                <div class="card-header d-flex">
                    <h4 class="card-header-title" style={{ fontWeight: 700, color: '#68a1c3' }}>Hoạt động lễ hội</h4>
                </div>
                <div className="card-body row justify-content-between">
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">
                                <img src="assets/images/team.png" width='68px' alt="item1" class="" />
                                <span>Danh sách T.Đồ</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">

                                <img src="assets/images/team_wm.png" width='68px' alt="item1" class="" />
                                <span>Danh sách T.Đồ WM</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">

                                <img src="assets/images/conversation.png" width='68px' alt="Báo cáo trundo" class="" />
                                <span>Báo cáo trundo</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <a href="/y-kien-cong-dong"><div className="item-block">
                            <img src="assets/images/clipboard.png" width='68px' alt="Đ.Ký PB" class="" />
                            <span>Đăng ký T.Đồ phát biểu</span>
                        </div>
                        </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <a href="/y-kien-cong-dong"><div className="item-block">
                            <img src="assets/images/student.png" width='68px' alt="Xác nhận phát biểu" class="" />
                            <span>Xác nhận phát biểu</span>
                        </div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="card">
                <div class="card-header d-flex">
                    <h4 class="card-header-title" style={{ fontWeight: 700, color: '#68a1c3' }}><i className="fas fa-fw fa-birthday-cake"></i> Nhà hàng</h4>
                </div>
                <div className="card-body row justify-content-between">
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">
                                <img src="assets/images/burger.png" width='68px' alt="Đăng ký suất ăn" class="" />
                                <span>Đăng ký suất ăn</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">
                                <img src="assets/images/seo-report.png" width='68px' alt="Thống kê suất ăn" class="" />
                                <span>Thống kê suất ăn</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">
                                <img src="assets/images/scooter.png" width='68px' alt="Nhận suất đi giao" class="" />
                                <span>Nhận suất đi giao</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <a href="/y-kien-cong-dong"><div className="item-block">
                            <img src="assets/images/food-donation.png" width='68px' alt="Giao shipper" class="" />
                            <span>Giao shipper</span>
                        </div>
                        </a>
                    </div>

                </div>
            </div>
            <div className="card">
                <div class="card-header d-flex">
                    <h4 class="card-header-title" style={{ fontWeight: 700, color: '#68a1c3' }}><i className="fas fa-fw fa-chart-bar"></i> Thống kê</h4>
                </div>
                <div className="card-body row justify-content-between">
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">
                                <img src="assets/images/person_analyst.png" width='68px' alt="Tổng hợp theo T.Đồ" class="" />
                                <span>Tổng hợp theo T.Đồ</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">

                                <img src="assets/images/project-management.png" width='68px' alt="Chi tiết theo T.Đồ" class="" />
                                <span>Chi tiết theo T.Đồ</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">

                                <img src="assets/images/analysis1.png" alt="Thống kê theo Địa vực" class="" />
                                <span>Thống kê theo Địa vực</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <Link to='/desktop'>
                            <div className="item-block">

                                <img src="assets/images/analysis2.png" alt="Thống kê theo Khu vực" class="" />
                                <span>Thống kê theo Khu vực</span>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <a href="/y-kien-cong-dong"><div className="item-block">
                            <img src="data:image/png;base64,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" alt="item1" class="" />
                            <span>Thống kê theo T.Đồ WM</span>
                        </div>
                        </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 col-xl-2 item">
                        <a href="/y-kien-cong-dong"><div className="item-block">
                            <img src="assets/images/team1_training.png" width='68px' alt="Thống kê theo đội WM" class="" />
                            <span>Thống kê theo đội WM</span>
                        </div>
                        </a>
                    </div>
                </div>
            </div>
            
        </>
    )
}